import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M400 262.913H0v.2h400z"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M400 262.914H0v.2h400z",
        opacity: ".12"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M84.7911 272.4h-43.472v.2h43.472z"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M84.7911 272.4h-43.472v.2h43.472z",
        opacity: ".12"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M200.799 268.058h-16.368v.2h16.368z"
    }, "4"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M200.799 268.058h-16.368v.2h16.368z",
        opacity: ".12"
    }, "5"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M145.025 268.058h-23.952v.2h23.952z"
    }, "6"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M145.025 268.058h-23.952v.2h23.952z",
        opacity: ".12"
    }, "7"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M343.128 270.361h-50.672v.2h50.672z"
    }, "8"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M343.128 270.361h-50.672v.2h50.672z",
        opacity: ".12"
    }, "9"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M191.376 270.361h-11.432v.2h11.432z"
    }, "10"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M191.376 270.361h-11.432v.2h11.432z",
        opacity: ".12"
    }, "11"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M103.2 272.401H92.5359v.2H103.2z"
    }, "12"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M103.2 272.4H92.5356v.2H103.2z",
        opacity: ".12"
    }, "13"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M356.473 270.361h-6.808v.2h6.808z"
    }, "14"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M356.473 270.361h-6.808v.2h6.808z",
        opacity: ".12"
    }, "15"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M189.6 227.233H35.1281a4.566 4.566 0 0 1-3.2249-1.341 4.567 4.567 0 0 1-1.3351-3.227V5.5212a4.568 4.568 0 0 1 4.56-4.528H189.6c1.212 0 2.374.4812 3.23 1.3379a4.567 4.567 0 0 1 1.338 3.23V222.665c0 1.212-.481 2.374-1.338 3.23a4.565 4.565 0 0 1-3.23 1.338M35.1281 1.1532a4.368 4.368 0 0 0-4.36 4.368V222.665c0 1.157.4591 2.267 1.2765 3.086a4.367 4.367 0 0 0 3.0835 1.282H189.6a4.372 4.372 0 0 0 3.086-1.282 4.372 4.372 0 0 0 1.282-3.086V5.5212a4.375 4.375 0 0 0-1.282-3.0863 4.374 4.374 0 0 0-3.086-1.2817z"
    }, "16"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M189.6 227.233H35.1276a4.566 4.566 0 0 1-3.2249-1.341 4.567 4.567 0 0 1-1.3351-3.227V5.5212a4.5683 4.5683 0 0 1 4.56-4.528H189.6c1.211 0 2.373.4812 3.23 1.3379a4.57 4.57 0 0 1 1.338 3.23V222.665a4.568 4.568 0 0 1-4.568 4.568M35.1276 1.1532a4.368 4.368 0 0 0-4.36 4.368V222.665c0 1.157.4591 2.267 1.2766 3.086a4.367 4.367 0 0 0 3.0834 1.282H189.6a4.376 4.376 0 0 0 3.086-1.282 4.372 4.372 0 0 0 1.282-3.086V5.5212a4.375 4.375 0 0 0-1.282-3.0863 4.377 4.377 0 0 0-3.086-1.2817z",
        opacity: ".12"
    }, "17"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M362.648 227.233h-154.48a4.578 4.578 0 0 1-3.228-1.34 4.576 4.576 0 0 1-1.34-3.228V5.5212a4.578 4.578 0 0 1 1.354-3.202 4.577 4.577 0 0 1 3.214-1.326h154.48a4.568 4.568 0 0 1 3.206 1.3294 4.566 4.566 0 0 1 1.346 3.1986V222.665a4.57 4.57 0 0 1-1.332 3.225 4.567 4.567 0 0 1-3.22 1.343M208.168 1.1532a4.374 4.374 0 0 0-3.086 1.2817 4.375 4.375 0 0 0-1.282 3.0863V222.665a4.372 4.372 0 0 0 1.282 3.086c.818.819 1.928 1.28 3.086 1.282h154.48a4.372 4.372 0 0 0 3.086-1.282 4.372 4.372 0 0 0 1.282-3.086V5.5212a4.375 4.375 0 0 0-1.282-3.0863 4.374 4.374 0 0 0-3.086-1.2817z"
    }, "18"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M362.648 227.233h-154.48a4.576 4.576 0 0 1-3.228-1.34 4.576 4.576 0 0 1-1.34-3.228V5.5212a4.573 4.573 0 0 1 1.354-3.202 4.577 4.577 0 0 1 3.214-1.326h154.48a4.568 4.568 0 0 1 3.205 1.3294 4.57 4.57 0 0 1 1.347 3.1986V222.665c0 1.209-.479 2.368-1.333 3.225a4.567 4.567 0 0 1-3.219 1.343M208.168 1.1532a4.378 4.378 0 0 0-3.087 1.2817 4.378 4.378 0 0 0-1.281 3.0863V222.665a4.3755 4.3755 0 0 0 4.368 4.368h154.48a4.376 4.376 0 0 0 3.086-1.282 4.377 4.377 0 0 0 1.282-3.086V5.5212a4.38 4.38 0 0 0-1.282-3.0863 4.377 4.377 0 0 0-3.086-1.2817z",
        opacity: ".12"
    }, "19"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M329.728 25.4414H151.416V129.089h178.312z"
    }, "20"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M329.728 25.4404H151.416V129.088h178.312z",
        opacity: ".12"
    }, "21"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M332.136 25.4414H153.824V129.089h178.312z"
    }, "22"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M332.136 25.4404H153.824V129.088h178.312z",
        opacity: ".06"
    }, "23"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M327.807 124.226V30.3057H158.151v93.9203z",
        opacity: ".9"
    }, "24"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M327.816 124.225V30.3047h-1.824v93.9203z"
    }, "25"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M327.816 124.226V30.3057h-1.824v93.9203z",
        opacity: ".12"
    }, "26"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M330.351 95.0332H155.615v6.5278h174.736z"
    }, "27"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M330.351 95.0322H155.615v6.5278h174.736z",
        opacity: ".06"
    }, "28"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M202.4 193.881h-29.28v64.92h29.28z"
    }, "29"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M202.4 193.881h-29.28v64.92h29.28z",
        opacity: ".12"
    }, "30"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M307.631 258.801H178.735v4.112h128.896z"
    }, "31"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M307.631 258.8H178.735v4.112h128.896z",
        opacity: ".12"
    }, "32"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M202.392 258.801h110.864v-64.92H202.392z"
    }, "33"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M202.391 258.8h110.864v-64.92H202.391z",
        opacity: ".06"
    }, "34"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M213.912 223.161h87.84v-21.288h-87.84z"
    }, "35"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M213.912 223.161h87.84v-21.288h-87.84z",
        opacity: ".12"
    }, "36"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M213.912 250.801h87.84v-21.288h-87.84z"
    }, "37"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M213.912 250.801h87.84v-21.288h-87.84z",
        opacity: ".12"
    }, "38"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M271 211.058h-26.336c-.711 0-1.288.576-1.288 1.288v.344c0 .711.577 1.288 1.288 1.288H271c.711 0 1.288-.577 1.288-1.288v-.344c0-.712-.577-1.288-1.288-1.288"
    }, "39"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M271 211.057h-26.336c-.712 0-1.288.576-1.288 1.288v.344c0 .711.576 1.288 1.288 1.288H271c.711 0 1.288-.577 1.288-1.288v-.344c0-.712-.577-1.288-1.288-1.288",
        opacity: ".06"
    }, "40"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M271 238.705h-26.336c-.711 0-1.288.577-1.288 1.288v.344c0 .711.577 1.288 1.288 1.288H271c.711 0 1.288-.577 1.288-1.288v-.344c0-.711-.577-1.288-1.288-1.288"
    }, "41"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M271 238.705h-26.336c-.712 0-1.288.577-1.288 1.288v.344c0 .711.576 1.288 1.288 1.288H271c.711 0 1.288-.577 1.288-1.288v-.344c0-.711-.577-1.288-1.288-1.288",
        opacity: ".06"
    }, "42"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M114.703 262.914H52.3273l-8.6-206.9365h62.3757z"
    }, "43"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M114.703 262.914H52.3273l-8.6-206.9365h62.3757z",
        opacity: ".12"
    }, "44"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M123.736 262.914H53.9281l-8.6-206.9365h69.8079z"
    }, "45"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M123.736 262.914H53.9281l-8.6-206.9365h69.8079z",
        opacity: ".06"
    }, "46"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "m60.824 255.713-8-192.5362h55.408l8.008 192.5362zm167.12-71.848c.8-21.856 1.6-52.136-.088-63.096l-2.76-2.136s.6 2.04.92 35.528.712 24.728.376 29.704z"
    }, "47"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M227.944 183.865c.8-21.856 1.6-52.136-.088-63.096l-2.76-2.136s.6 2.04.92 35.528.712 24.728.376 29.704z",
        opacity: ".15"
    }, "48"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M233.08 111.465c5.104-6.92 15.848-11.8395 26.976-11.8155 4.368 0-13.008 8.0475-20.04 16.9195-5.464 6.888-11.488 18.48-13.456 24.912.944-13.536 1.44-23.104 6.52-30.016"
    }, "49"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M233.08 111.465c5.104-6.92 15.848-11.8395 26.976-11.8155 4.368 0-13.008 8.0475-20.04 16.9195-5.464 6.888-11.488 18.48-13.456 24.912.944-13.536 1.44-23.104 6.52-30.016",
        opacity: ".15"
    }, "50"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M222.839 129.489c-4.688-7.2-15.128-12.744-26.232-13.368-4.36-.248 12.512 8.8 19.016 18.056 5.048 7.2 10.4 19.12 12 25.664-.176-13.568-.088-23.144-4.784-30.352"
    }, "51"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M222.839 129.49c-4.688-7.2-15.128-12.744-26.232-13.368-4.36-.248 12.512 8.8 19.016 18.056 5.048 7.2 10.4 19.12 12 25.664-.176-13.568-.088-23.144-4.784-30.352",
        opacity: ".15"
    }, "52"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M224.937 99.9138c-4.272-8.4-14.24-16.504-25.08-19.8-4.264-1.296 13.392 13.488 18.44 24.8002 3.92 8.8 8.672 19.856 9.92 26.84.464-13.776.984-23.432-3.28-31.8402"
    }, "53"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M224.937 99.9148c-4.272-8.4-14.24-16.504-25.08-19.8-4.264-1.296 13.392 13.488 18.44 24.8002 3.92 8.8 8.672 19.856 9.92 26.84.464-13.776.984-23.432-3.28-31.8402",
        opacity: ".15"
    }, "54"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M226.913 193.881c2.598 0 5.096-.996 6.983-2.781a10.157 10.157 0 0 0 3.161-6.819l.896-15.6h-22.08l.904 15.6a10.15 10.15 0 0 0 3.156 6.818 10.153 10.153 0 0 0 6.98 2.782"
    }, "55"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#000",
        fillOpacity: ".08",
        d: "M226.913 193.882c2.598-.001 5.096-.996 6.983-2.781a10.157 10.157 0 0 0 3.161-6.819l.896-15.6h-22.08l.904 15.6a10.15 10.15 0 0 0 3.156 6.818 10.153 10.153 0 0 0 6.98 2.782"
    }, "56"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M214.447 172.242h24.936l.712-6.472h-26.368z"
    }, "57"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M214.447 172.24h24.936l.712-6.472h-26.368z",
        opacity: ".1"
    }, "58"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M320.455 65.1211h16.512v-44.8h-16.512z"
    }, "59"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M320.455 65.1211h16.512v-44.8h-16.512z",
        opacity: ".12"
    }, "60"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M320.456 20.3291h-8.184v41.2h8.184z"
    }, "61"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M320.455 20.3291h-8.184v41.2h8.184z",
        opacity: ".06"
    }, "62"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M295.76 65.1211h16.512v-44.8H295.76z"
    }, "63"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M295.759 65.1211h16.512v-44.8h-16.512z",
        opacity: ".12"
    }, "64"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M295.76 20.3291h-8.184v41.2h8.184z"
    }, "65"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M295.76 20.3291h-8.184v41.2h8.184z",
        opacity: ".06"
    }, "66"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M271.064 65.1211h16.512v-44.8h-16.512z"
    }, "67"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M271.064 65.1211h16.512v-44.8h-16.512z",
        opacity: ".12"
    }, "68"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M271.065 20.3291h-8.184v41.2h8.184z"
    }, "69"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M271.065 20.3291h-8.184v41.2h8.184z",
        opacity: ".06"
    }, "70"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M246.36 65.1211h16.512v-44.8H246.36z"
    }, "71"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M246.36 65.1211h16.512v-44.8H246.36z",
        opacity: ".12"
    }, "72"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M246.36 20.3291h-8.184v41.2h8.184z"
    }, "73"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M246.361 20.3291h-8.184v41.2h8.184z",
        opacity: ".06"
    }, "74"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M221.671 65.1211h16.512v-44.8h-16.512z"
    }, "75"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M221.671 65.1211h16.512v-44.8h-16.512z",
        opacity: ".12"
    }, "76"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M221.665 20.3291h-8.184v41.2h8.184z"
    }, "77"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M221.665 20.3291h-8.184v41.2h8.184z",
        opacity: ".06"
    }, "78"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M196.969 65.1211h16.512v-44.8h-16.512z"
    }, "79"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M196.969 65.1211h16.512v-44.8h-16.512z",
        opacity: ".12"
    }, "80"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M196.967 20.3291h-8.184v41.2h8.184z"
    }, "81"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M196.967 20.3291h-8.184v41.2h8.184z",
        opacity: ".06"
    }, "82"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M172.271 65.1211h16.512v-44.8h-16.512z"
    }, "83"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M172.271 65.1211h16.512v-44.8h-16.512z",
        opacity: ".12"
    }, "84"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M172.272 20.3291h-8.184v41.2h8.184z"
    }, "85"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M172.272 20.3291h-8.184v41.2h8.184z",
        opacity: ".06"
    }, "86"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M147.576 65.1211h16.512v-44.8h-16.512z"
    }, "87"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M147.576 65.1211h16.512v-44.8h-16.512z",
        opacity: ".12"
    }, "88"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M199.999 299.042c85.666 0 155.112-4.055 155.112-9.056 0-5.002-69.446-9.056-155.112-9.056s-155.1115 4.054-155.1115 9.056c0 5.001 69.4455 9.056 155.1115 9.056"
    }, "89"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M199.999 299.042c85.666 0 155.112-4.055 155.112-9.056 0-5.002-69.446-9.056-155.112-9.056s-155.1115 4.054-155.1115 9.056c0 5.001 69.4455 9.056 155.1115 9.056",
        opacity: ".06"
    }, "90"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#9F5B53",
        d: "m281.936 132.617 3.4 5.2 5.056-1.048-3.816-6.464zm9.64-44.5682c.72.872 1.32 1.648 1.936 2.496s1.208 1.664 1.792 2.512c1.168 1.688 2.28 3.424 3.32 5.208 1.04 1.7842 2.048 3.6082 2.928 5.5202.472.936.872 1.928 1.304 2.896s.8 1.984 1.112 3.032l.256.8.128.392c.072.232.144.48.192.712.176.83.235 1.681.176 2.528a14.5 14.5 0 0 1-.856 3.88 31.22 31.22 0 0 1-2.992 5.936 58.68 58.68 0 0 1-7.776 9.6l-3.496-2.736c1.922-3.281 3.679-6.656 5.264-10.112.728-1.578 1.309-3.22 1.736-4.904a7.22 7.22 0 0 0 .216-1.936.98.98 0 0 0-.088-.4l-.128-.304-.264-.608a68.86 68.86 0 0 0-5.28-9.688c-1.008-1.6-2.072-3.1442-3.144-4.7042s-2.24-3.12-3.296-4.536z"
    }, "91"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M289.599 84.1135c5.512 1.264 11.832 16.2805 11.832 16.2805l-11.032 7.584a93.3 93.3 0 0 1-7.312-12.4245c-3.272-6.872.912-12.728 6.512-11.44"
    }, "92"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M289.599 84.1135c5.512 1.264 11.832 16.2805 11.832 16.2805l-11.032 7.584a93.3 93.3 0 0 1-7.312-12.4245c-3.272-6.872.912-12.728 6.512-11.44",
        opacity: ".8"
    }, "93"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "m285.681 93.6895 5.232 13.9275-.52.36s-2.264-3.2-4.712-7.464z"
    }, "94"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "m285.681 93.6895 5.232 13.9275-.52.36s-2.264-3.2-4.712-7.464z",
        opacity: ".6"
    }, "95"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#9F5B53",
        d: "M271.711 284.706h-5.88l-.584-13.608h5.88zm35.289-.001h-5.88l-2.952-13.608h5.872z"
    }, "96"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#8A4743",
        d: "m265.247 271.105.304 7.008h5.88l-.304-7.008zm38.801 0h-5.88l1.52 7.008h5.88z"
    }, "97"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M267.505 135.217s6.672 44.912 10.328 61.736c4 18.4 19.12 79.808 19.12 79.808h10.768s-9.968-59.896-12.256-78.168c-2.48-19.8-7.672-63.408-7.672-63.408z"
    }, "98"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M267.505 135.217s6.672 44.912 10.328 61.736c4 18.4 19.12 79.808 19.12 79.808h10.768s-9.968-59.896-12.256-78.168c-2.48-19.8-7.672-63.408-7.672-63.408z",
        opacity: ".1"
    }, "99"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M271.721 151.217c7.712 1.512 6.896 30.272 5.968 45.064-2.224-10.456-5.48-30.576-7.704-44.856.538-.265 1.15-.338 1.736-.208",
        opacity: ".2"
    }, "100"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M256.352 135.217s-.8 43.936-.168 61.864c.664 18.64 7.2 79.68 7.2 79.68h9.952s.368-59.952.8-78.256c.48-19.96 2.888-63.288 2.888-63.288z"
    }, "101"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M256.352 135.217s-.8 43.936-.168 61.864c.664 18.64 7.2 79.68 7.2 79.68h9.952s.368-59.952.8-78.256c.48-19.96 2.888-63.288 2.888-63.288z",
        opacity: ".1"
    }, "102"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#9F5B53",
        d: "m290.872 129.569-4.296.736 3.816 6.464s2.992-1.44 3.536-4.232z"
    }, "103"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M262.481 62.273c0 .472-.248.856-.56.856s-.56-.384-.56-.856.248-.856.56-.856.56.376.56.856"
    }, "104"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#892B29",
        d: "M262.272 63.1289a17.06 17.06 0 0 1-2.264 4.056 2.728 2.728 0 0 0 2.264.424z"
    }, "105"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M264.16 59.6492a.248.248 0 0 1-.16-.056 2.199 2.199 0 0 0-1.984-.36.272.272 0 0 1-.296-.069.26.26 0 0 1-.056-.091.28.28 0 0 1-.022-.1061.277.277 0 0 1 .083-.1955.27.27 0 0 1 .091-.0584 2.734 2.734 0 0 1 1.305-.0923c.436.0752.848.2551 1.199.5243a.26.26 0 0 1 .116.1779.265.265 0 0 1-.004.1086.26.26 0 0 1-.048.0975.255.255 0 0 1-.224.12"
    }, "106"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#9F5B53",
        d: "M277.783 67.7363c-.848 4.304-1.688 12.176 1.32 15.048 0 0-1.176 4.36-9.168 4.36-8.8 0-4.192-4.36-4.192-4.36 4.8-1.144 4.672-4.704 3.832-8.04z"
    }, "107"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M280.256 84.2813c.632-1.376 1.32-2.96-.112-3.456-1.6-.544-10.216-1.096-13.192-.08-.393.1088-.76.2944-1.08.5461s-.588.5644-.786.92a3.07 3.07 0 0 0-.371 1.1519c-.047.4048-.012.8147.101 1.206zm18.505 200.7117a1.882 1.882 0 0 1-1.408-.384.557.557 0 0 1-.109-.332c0-.119.038-.236.109-.332a.64.64 0 0 1 .18-.211.65.65 0 0 1 .252-.117c.864-.192 2.48.912 2.552.96.022.016.039.038.049.064.01.025.012.053.007.08a.13.13 0 0 1-.035.069.13.13 0 0 1-.069.035c-.502.109-1.014.165-1.528.168m-.728-1.12h-.176a.36.36 0 0 0-.149.068.365.365 0 0 0-.107.124c-.128.224-.048.32 0 .352.248.336 1.448.336 2.328.192a4.6 4.6 0 0 0-1.896-.72z"
    }, "108"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M300.264 284.849h-.064c-.608-.336-1.784-1.6-1.664-2.272a.453.453 0 0 1 .158-.265.457.457 0 0 1 .29-.103.795.795 0 0 1 .314.028c.101.031.196.081.278.148.68.56.8 2.256.8 2.328a.123.123 0 0 1-.013.073.13.13 0 0 1-.051.055.11.11 0 0 1-.048.008m-1.184-2.4h-.064c-.184 0-.2.112-.208.144-.072.392.68 1.36 1.28 1.816a3.373 3.373 0 0 0-.688-1.84.507.507 0 0 0-.32-.104zm-35.609 2.544c-.752 0-1.48-.104-1.728-.44a.538.538 0 0 1 0-.608.66.66 0 0 1 .185-.211.67.67 0 0 1 .255-.117c.968-.264 3.032.904 3.12.952.024.015.042.037.054.062a.144.144 0 0 1 .01.082.126.126 0 0 1-.036.075.125.125 0 0 1-.076.037c-.588.111-1.185.167-1.784.168m-.936-1.136a.9.9 0 0 0-.264 0 .41.41 0 0 0-.156.067.42.42 0 0 0-.116.125c-.096.176-.064.256 0 .304.272.368 1.752.392 2.856.24a6.3 6.3 0 0 0-2.32-.72z"
    }, "109"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M265.247 284.849h-.056c-.712-.312-2.112-1.6-2.008-2.248 0-.16.136-.352.52-.392a.99.99 0 0 1 .427.03.985.985 0 0 1 .373.21c.752.608.904 2.192.912 2.264.003.025 0 .05-.01.072a.133.133 0 0 1-.046.056.12.12 0 0 1-.055.016.124.124 0 0 1-.057-.008m-1.432-2.4h-.088c-.248 0-.264.128-.272.16-.064.4.896 1.4 1.6 1.832a3.198 3.198 0 0 0-.8-1.808.695.695 0 0 0-.44-.168z"
    }, "110"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M300.705 284.025h6.6a.521.521 0 0 1 .504.408l1.16 5.224c.026.128.024.259-.008.385a.86.86 0 0 1-.173.344c-.083.1-.188.18-.306.234a.86.86 0 0 1-.377.077c-2.304-.04-3.424-.176-6.328-.176-1.784 0-5.464.192-7.936.192s-2.784-2.4-1.776-2.664c4.528-.992 6.232-2.36 7.688-3.656.259-.238.599-.37.952-.368m-34.834 0h6.4a.524.524 0 0 1 .324.116c.091.074.155.177.18.292l1.16 5.224a.854.854 0 0 1-.172.725c-.082.1-.185.181-.302.235a.85.85 0 0 1-.374.08c-2.312-.04-5.656-.176-8.568-.176-3.4 0-6.344.192-10.336.192-2.4 0-3.08-2.4-2.072-2.664 4.6-1.008 8.352-1.112 12.328-3.56.424-.288.92-.448 1.432-.464"
    }, "111"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#9F5B53",
        d: "M257.48 96.1372c-2.328 3.44-4.736 6.6478-7.336 9.8318a109 109 0 0 1-8.32 9.184l-1.152 1.088-.296.272-.2.184-.296.256c-.38.3-.784.567-1.208.8a10.735 10.735 0 0 1-4.36 1.216c-2.325.145-4.658-.046-6.928-.568a52.56 52.56 0 0 1-11.88-4.176l1.464-4.16c3.749.746 7.54 1.262 11.352 1.544 1.674.137 3.359.067 5.016-.208.475-.069.929-.244 1.328-.512v-.056l.056-.064.24-.264.944-1.04c2.504-2.856 4.928-5.888 7.28-9 2.352-3.1118 4.704-6.2798 6.952-9.3918z"
    }, "112"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M260.193 97.0576a27.89 27.89 0 0 1-6.208 13.4564c-.128-2.816-.176-5.344-.168-7.608z"
    }, "113"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M260.193 97.0557a27.89 27.89 0 0 1-6.208 13.4563c-.128-2.816-.176-5.344-.168-7.608z",
        opacity: ".3"
    }, "114"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#9F5B53",
        d: "M278.288 61.2656c-.352 5.824-.264 9.248-3.2 12.24-4.424 4.496-11.608 1.824-13-4-1.248-5.232-.456-13.872 5.248-16.192a7.95 7.95 0 0 1 7.694.9205 7.96 7.96 0 0 1 2.544 3.0921 7.95 7.95 0 0 1 .714 3.9394"
    }, "115"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M266.976 57.3931c.048 6.848 2.272 15.248 8.896 14.664 4.4-.384 7.744-8.408 8.2-11.808.696-5.2.8-6.192-2.128-6.792 1.28-.696 1.744-4-1.248-4.8-4.16-1.096-12-2.168-9.536-4.704-4.912.888-6.144 2.856-5.248 5.248-2.872-.224-4.64-1.728-4.552-4-4.76 1.928-7.848 12.832 5.616 12.192"
    }, "116"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#9F5B53",
        d: "M270.401 62.961a6.578 6.578 0 0 1-2.224 3.6c-1.48 1.2-2.664.128-2.632-1.6 0-1.56.848-4.0641 2.512-4.5921s2.752.8881 2.344 2.5921"
    }, "117"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#263238",
        d: "M286.4 54.6492a5.6 5.6 0 0 0-2.604-.8618 5.6 5.6 0 0 0-2.7.4778s3.328-4.472 5.304.384"
    }, "118"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M295.199 272.793c-.048 0 1.112 4.136 1.112 4.136h12.112l-.224-3.688zm-33.752 0c-.048 0 .56 4.136.56 4.136h12.112l.328-3.688zm3.985-3.184a.096.096 0 0 1-.096-.088c-1.76-16.896-5.896-57.776-6.4-72.44-.536-14.968-.048-48.552.112-58.488 0-.056.048-.088.104-.096a.11.11 0 0 1 .066.03.11.11 0 0 1 .03.066c-.16 9.936-.648 43.52-.112 58.48.52 14.664 4.656 55.528 6.4 72.424a.1126.1126 0 0 1-.096.112z"
    }, "119"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M265.432 269.609a.096.096 0 0 1-.096-.088c-1.76-16.896-5.896-57.776-6.4-72.44-.536-14.968-.048-48.552.112-58.488 0-.056.048-.088.104-.096a.11.11 0 0 1 .066.03.11.11 0 0 1 .03.066c-.16 9.936-.648 43.52-.112 58.48.52 14.664 4.656 55.528 6.4 72.424a.1126.1126 0 0 1-.096.112z",
        opacity: ".3"
    }, "120"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M262.904 89.1774c.8 5.6-10.192 19.7836-10.192 19.7836l-11.016-7.584s3.056-7.8316 8.2-12.9676c5.872-5.816 12.16-5.288 13.008.768"
    }, "121"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M262.904 89.1774c.8 5.6-10.192 19.7836-10.192 19.7836l-11.016-7.584s3.056-7.8316 8.2-12.9676c5.872-5.816 12.16-5.288 13.008.768",
        opacity: ".8"
    }, "122"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M256.704 84.4169s-6.256 7.064-.352 50.8001h31.44c.216-4.8-2.816-28.368 1.832-51.1041a82 82 0 0 0-10.52-1.328c-4.45-.2562-8.91-.2562-13.36 0a58.8 58.8 0 0 0-9.04 1.632"
    }, "123"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M256.704 84.4169s-6.256 7.064-.352 50.8001h31.44c.216-4.8-2.816-28.368 1.832-51.1041a82 82 0 0 0-10.52-1.328c-4.45-.2562-8.91-.2562-13.36 0a58.8 58.8 0 0 0-9.04 1.632",
        opacity: ".8"
    }, "124"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M164.206 52.3082c2.511-11.0603-4.42-22.0619-15.48-24.5727s-22.062 4.4199-24.573 15.4802c-2.51 11.0603 4.42 22.0619 15.481 24.5727 11.06 2.5108 22.062-4.4199 24.572-15.4802"
    }, "125"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M164.206 52.3082c2.511-11.0603-4.42-22.0619-15.48-24.5727s-22.062 4.4199-24.573 15.4802c-2.51 11.0603 4.42 22.0619 15.481 24.5727 11.06 2.5108 22.062-4.4199 24.572-15.4802",
        opacity: ".2"
    }, "126"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M142.07 74.3917a26.59 26.59 0 0 1-14.541-5.7301 26.596 26.596 0 0 1-8.811-12.9099l.76-.24a25.801 25.801 0 0 0 22.656 18.08z"
    }, "127"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M142.07 74.3917a26.59 26.59 0 0 1-14.541-5.7301 26.596 26.596 0 0 1-8.811-12.9099l.76-.24a25.801 25.801 0 0 0 22.656 18.08z",
        opacity: ".2"
    }, "128"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "m119.367 40.3684-.8-.224a26.703 26.703 0 0 1 13.38-16.0962 26.702 26.702 0 0 1 20.876-1.5038l-.256.76a25.92 25.92 0 0 0-20.261 1.4691 25.92 25.92 0 0 0-8.084 6.489 25.93 25.93 0 0 0-4.895 9.1379z"
    }, "129"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "m119.367 40.3684-.8-.224a26.703 26.703 0 0 1 13.38-16.0962 26.702 26.702 0 0 1 20.876-1.5038l-.256.76a25.92 25.92 0 0 0-20.261 1.4691 25.92 25.92 0 0 0-8.084 6.489 25.93 25.93 0 0 0-4.895 9.1379z",
        opacity: ".2"
    }, "130"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M168.91 40.0242a25.84 25.84 0 0 0-11.2-14.344l.416-.688a26.68 26.68 0 0 1 11.536 14.792z"
    }, "131"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M168.91 40.0242a25.84 25.84 0 0 0-11.2-14.344l.416-.688a26.68 26.68 0 0 1 11.536 14.792z",
        opacity: ".2"
    }, "132"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M164.216 108.996c2.51-11.0606-4.42-22.0622-15.481-24.573-11.06-2.5108-22.062 4.4199-24.572 15.4802-2.511 11.0608 4.42 22.0618 15.48 24.5728s22.062-4.42 24.573-15.48"
    }, "133"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M164.216 108.996c2.51-11.0606-4.42-22.0622-15.481-24.573-11.06-2.5108-22.062 4.4199-24.572 15.4802-2.511 11.0608 4.42 22.0618 15.48 24.5728s22.062-4.42 24.573-15.48",
        opacity: ".6"
    }, "134"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M164.208 165.681c2.511-11.06-4.42-22.062-15.48-24.572-11.06-2.511-22.062 4.419-24.573 15.48-2.51 11.06 4.42 22.062 15.481 24.572 11.06 2.511 22.061-4.419 24.572-15.48"
    }, "135"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M164.208 165.681c2.511-11.06-4.42-22.062-15.48-24.572-11.06-2.511-22.062 4.419-24.573 15.48-2.51 11.06 4.42 22.062 15.481 24.572 11.06 2.511 22.061-4.419 24.572-15.48",
        opacity: ".6"
    }, "136"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M164.21 222.377c2.511-11.061-4.42-22.062-15.48-24.573s-22.062 4.42-24.573 15.48 4.42 22.062 15.481 24.573c11.06 2.511 22.061-4.42 24.572-15.48"
    }, "137"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M164.21 222.377c2.511-11.061-4.42-22.062-15.48-24.573s-22.062 4.42-24.573 15.48 4.42 22.062 15.481 24.573c11.06 2.511 22.061-4.42 24.572-15.48",
        opacity: ".6"
    }, "138"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M107.521 52.3013c2.511-11.0603-4.42-22.0618-15.4805-24.5727-11.0603-2.5108-22.0618 4.42-24.5726 15.4803-2.5109 11.0603 4.4199 22.0619 15.4802 24.5727s22.0619-4.42 24.5729-15.4803"
    }, "139"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M107.521 52.3013c2.511-11.0603-4.42-22.0618-15.4805-24.5727-11.0603-2.5108-22.0618 4.42-24.5726 15.4803-2.5109 11.0603 4.4199 22.0619 15.4802 24.5727s22.0619-4.42 24.5729-15.4803",
        opacity: ".6"
    }, "140"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M107.53 108.997c2.511-11.0607-4.42-22.0622-15.4802-24.573-11.0603-2.5109-22.0619 4.4199-24.5727 15.4802-2.5108 11.0608 4.42 22.0618 15.4803 24.5728s22.0616-4.42 24.5726-15.48"
    }, "141"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M107.53 108.997c2.511-11.0607-4.42-22.0622-15.4802-24.573-11.0603-2.5109-22.0619 4.4199-24.5727 15.4802-2.5108 11.0608 4.42 22.0618 15.4803 24.5728s22.0616-4.42 24.5726-15.48",
        opacity: ".6"
    }, "142"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M107.523 165.682c2.511-11.06-4.419-22.062-15.4798-24.572-11.0603-2.511-22.0618 4.419-24.5727 15.48-2.5108 11.06 4.42 22.062 15.4803 24.572 11.0603 2.511 22.0622-4.419 24.5722-15.48"
    }, "143"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M107.523 165.682c2.511-11.06-4.419-22.062-15.4798-24.572-11.0603-2.511-22.0618 4.419-24.5727 15.48-2.5108 11.06 4.42 22.062 15.4803 24.572 11.0603 2.511 22.0622-4.419 24.5722-15.48",
        opacity: ".6"
    }, "144"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M107.525 222.37c2.511-11.061-4.419-22.062-15.4798-24.573-11.0603-2.511-22.0619 4.42-24.5727 15.48-2.5108 11.061 4.4199 22.062 15.4802 24.573s22.0623-4.42 24.5723-15.48"
    }, "145"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-0,#FFFFFF)",
        d: "M107.525 222.37c2.511-11.061-4.419-22.062-15.4798-24.573-11.0603-2.511-22.0619 4.42-24.5727 15.48-2.5108 11.061 4.4199 22.062 15.4802 24.573s22.0623-4.42 24.5723-15.48",
        opacity: ".6"
    }, "146"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#9F5B53",
        d: "m217.76 110.497-4.312-4.464-4.6 5.936s3.504 3.376 7.672 2.4zm-10.241-6.911-1.968 6.224 3.296 2.16 4.6-5.936z"
    }, "147"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M148.801 103.922a7.738 7.738 0 0 1 4.443-4.7115 7.75 7.75 0 0 1 3.269-.553 7.75 7.75 0 0 1 3.2.8644l-4.8-2.496a7.916 7.916 0 0 1-3.847-4.297 7.918 7.918 0 0 1 .087-5.767 7.7603 7.7603 0 0 1 10.672-3.776l-4.8-2.488a7.92 7.92 0 0 1-3.851-4.3003 7.92 7.92 0 0 1 .091-5.7717 7.751 7.751 0 0 1 7.688-4.6458 7.755 7.755 0 0 1 3.048.8778l-22.792-11.92a7.888 7.888 0 0 1-3.734-3.9716 7.888 7.888 0 0 1-.266-5.4444 7.76 7.76 0 0 1 4.449-4.7078 7.761 7.761 0 0 1 6.471.3078l48 25.096-4.928-20.224a8.247 8.247 0 0 1 .849-5.9887 8.25 8.25 0 0 1 4.707-3.7989 8.2485 8.2485 0 0 1 10.148 4.8676l15.744 40.896a15.437 15.437 0 0 0 7.24 8.12l2.744 1.432c.42.2193.793.5194 1.098.8832.304.3639.533.7842.674 1.2369.142.4528.192.9289.149 1.4012-.044.4722-.18.9313-.401 1.3507l-19.2 36.6801a3.62 3.62 0 0 1-2.12 1.771 3.618 3.618 0 0 1-2.752-.243l-6.736-3.52a15.84 15.84 0 0 0-8.272-1.712 38.393 38.393 0 0 1-19.952-4.32l-22.4-11.712a7.886 7.886 0 0 1-3.92-9.416"
    }, "148"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M211.792 136.193a4.785 4.785 0 0 1-2.224-.544l-6.736-3.52a14.813 14.813 0 0 0-7.648-1.6 39.6 39.6 0 0 1-20.576-4.448l-22.4-11.712a9.106 9.106 0 0 1-4.258-4.601 9.11 9.11 0 0 1-.278-6.263 8.92 8.92 0 0 1 1.972-3.287 8.92 8.92 0 0 1 3.172-2.1526 7.7 7.7 0 0 1 1-.336 9.096 9.096 0 0 1-3.728-11.28 8.79 8.79 0 0 1 2.098-2.9809 8.8 8.8 0 0 1 3.126-1.8751c.216-.072.432-.144.648-.2a9.083 9.083 0 0 1-3.962-4.9465 9.082 9.082 0 0 1 .234-6.3335 8.79 8.79 0 0 1 2.099-2.9765 8.8 8.8 0 0 1 3.125-1.8715c.2-.072.408-.136.608-.192l-17.408-9.104a9.11 9.11 0 0 1-4.258-4.6011 9.11 9.11 0 0 1-.278-6.2629 8.965 8.965 0 0 1 1.974-3.2792 8.97 8.97 0 0 1 3.163-2.156 8.963 8.963 0 0 1 7.471.3552l45.672 23.904-4.312-17.656a9.444 9.444 0 0 1 .981-6.8553 9.442 9.442 0 0 1 5.396-4.3408 9.44 9.44 0 0 1 6.907.5099 9.443 9.443 0 0 1 4.7 5.0862l15.744 40.896a14.233 14.233 0 0 0 6.68 7.488l2.736 1.432a4.8 4.8 0 0 1 1.462 1.1757 4.8 4.8 0 0 1 .901 1.6466c.188.6027.256 1.2368.2 1.8658a4.82 4.82 0 0 1-.531 1.7999l-19.2 36.6876a4.803 4.803 0 0 1-1.784 1.86c-.753.445-1.613.676-2.488.668m-15.704-8.072c2.732-.014 5.427.63 7.856 1.88l6.736 3.52a2.397 2.397 0 0 0 1.84.171c.303-.094.584-.248.827-.451.243-.204.443-.454.589-.736l19.2-36.6876a2.406 2.406 0 0 0 .164-1.8371 2.4 2.4 0 0 0-.453-.8241 2.41 2.41 0 0 0-.735-.5868l-2.736-1.432a16.575 16.575 0 0 1-7.776-8.736l-15.752-40.896a7.042 7.042 0 0 0-3.503-3.8516 7.04 7.04 0 0 0-5.191-.3919 7.04 7.04 0 0 0-4.722 8.4435l4.944 20.232c.055.2232.044.4575-.031.6747a1.2 1.2 0 0 1-.393.5493 1.185 1.185 0 0 1-1.296.12l-48-25.096a6.54 6.54 0 0 0-2.699-.7293 6.54 6.54 0 0 0-2.757.4653 6.39 6.39 0 0 0-2.335 1.575 6.39 6.39 0 0 0-1.433 2.425 6.7 6.7 0 0 0 .218 4.6205 6.703 6.703 0 0 0 3.158 3.3795l22.8 11.92c.282.1475.494.401.589.7048a1.199 1.199 0 0 1-.375 1.2801 1.1995 1.1995 0 0 1-1.326.1431 6.545 6.545 0 0 0-5.2-.36 6.46 6.46 0 0 0-2.286 1.3689 6.46 6.46 0 0 0-1.538 2.1751 6.712 6.712 0 0 0 3.2 8.528l4.8 2.496a1.2001 1.2001 0 0 1-1.112 2.12 6.55 6.55 0 0 0-5.192-.36 6.47 6.47 0 0 0-2.286 1.3735 6.48 6.48 0 0 0-1.538 2.1785 6.71 6.71 0 0 0-.065 4.8852 6.713 6.713 0 0 0 3.265 3.6348l4.8 2.496c.282.1475.494.401.589.7048.096.3038.066.633-.081.9148a1.2 1.2 0 0 1-.705.59c-.304.095-.633.066-.915-.082a6.58 6.58 0 0 0-2.7-.7216 6.57 6.57 0 0 0-2.756.4656 6.45 6.45 0 0 0-2.327 1.58 6.46 6.46 0 0 0-1.433 2.42 6.698 6.698 0 0 0 .215 4.622 6.69 6.69 0 0 0 3.161 3.378l22.4 11.712a37.28 37.28 0 0 0 19.256 4.104c.352 0 .696-.056 1.04-.056z"
    }, "149"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M165.703 103.85a1.19 1.19 0 0 1-.56-.136l-5.944-3.128c-.14-.073-.264-.173-.365-.294a1.22 1.22 0 0 1-.225-.411 1.2014 1.2014 0 0 1 1.252-1.555c.157.014.31.0588.45.1318l5.976 3.1282c.238.124.427.324.538.569a1.2 1.2 0 0 1 .073.779c-.064.261-.213.493-.424.659-.21.166-.471.256-.739.257zm2.144-16.3372a1.16 1.16 0 0 1-.56-.136l-5.976-3.128a1.2 1.2 0 0 1-.399-.2831 1.21 1.21 0 0 1-.253-.4187 1.21 1.21 0 0 1-.064-.4848c.012-.1644.057-.3245.134-.4704.076-.1459.182-.2745.311-.3777a1.198 1.198 0 0 1 .923-.2525c.163.0236.32.0805.46.1672l5.976 3.12c.238.1241.427.3243.538.5687s.137.5189.073.7796a1.206 1.206 0 0 1-.423.6585c-.211.166-.472.2566-.74.2572m2.137-16.3271a1.25 1.25 0 0 1-.552-.136l-5.976-3.128a1.2 1.2 0 0 1-.59-.7048 1.202 1.202 0 0 1 .376-1.28c.12-.1012.26-.1775.411-.2247.15-.0472.308-.0642.465-.0502s.31.0587.45.1317l5.976 3.128c.238.1244.428.3253.539.5706.11.2452.135.5204.071.7816-.065.2611-.215.493-.427.6583a1.202 1.202 0 0 1-.743.2535"
    }, "150"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-1000,#121212)",
        d: "M211.792 136.193a4.785 4.785 0 0 1-2.224-.544l-6.736-3.52a14.813 14.813 0 0 0-7.648-1.6 39.6 39.6 0 0 1-20.576-4.448l-22.4-11.712a9.106 9.106 0 0 1-4.258-4.601 9.11 9.11 0 0 1-.278-6.263 8.92 8.92 0 0 1 1.972-3.287 8.92 8.92 0 0 1 3.172-2.1526 7.7 7.7 0 0 1 1-.336 9.096 9.096 0 0 1-3.728-11.28 8.79 8.79 0 0 1 2.098-2.9809 8.8 8.8 0 0 1 3.126-1.8751c.216-.072.432-.144.648-.2a9.083 9.083 0 0 1-3.962-4.9465 9.082 9.082 0 0 1 .234-6.3335 8.79 8.79 0 0 1 2.099-2.9765 8.8 8.8 0 0 1 3.125-1.8715c.2-.072.408-.136.608-.192l-17.408-9.104a9.11 9.11 0 0 1-4.258-4.6011 9.11 9.11 0 0 1-.278-6.2629 8.965 8.965 0 0 1 1.974-3.2792 8.97 8.97 0 0 1 3.163-2.156 8.963 8.963 0 0 1 7.471.3552l45.672 23.904-4.312-17.656a9.444 9.444 0 0 1 .981-6.8553 9.442 9.442 0 0 1 5.396-4.3408 9.44 9.44 0 0 1 6.907.5099 9.443 9.443 0 0 1 4.7 5.0862l15.744 40.896a14.233 14.233 0 0 0 6.68 7.488l2.736 1.432a4.8 4.8 0 0 1 1.462 1.1757 4.8 4.8 0 0 1 .901 1.6466c.188.6027.256 1.2368.2 1.8658a4.82 4.82 0 0 1-.531 1.7999l-19.2 36.6876a4.803 4.803 0 0 1-1.784 1.86c-.753.445-1.613.676-2.488.668m-15.704-8.072c2.732-.014 5.427.63 7.856 1.88l6.736 3.52a2.397 2.397 0 0 0 1.84.171c.303-.094.584-.248.827-.451.243-.204.443-.454.589-.736l19.2-36.6876a2.406 2.406 0 0 0 .164-1.8371 2.4 2.4 0 0 0-.453-.8241 2.41 2.41 0 0 0-.735-.5868l-2.736-1.432a16.575 16.575 0 0 1-7.776-8.736l-15.752-40.896a7.042 7.042 0 0 0-3.503-3.8516 7.04 7.04 0 0 0-5.191-.3919 7.04 7.04 0 0 0-4.722 8.4435l4.944 20.232c.055.2232.044.4575-.031.6747a1.2 1.2 0 0 1-.393.5493 1.185 1.185 0 0 1-1.296.12l-48-25.096a6.54 6.54 0 0 0-2.699-.7293 6.54 6.54 0 0 0-2.757.4653 6.39 6.39 0 0 0-2.335 1.575 6.39 6.39 0 0 0-1.433 2.425 6.7 6.7 0 0 0 .218 4.6205 6.703 6.703 0 0 0 3.158 3.3795l22.8 11.92c.282.1475.494.401.589.7048a1.199 1.199 0 0 1-.375 1.2801 1.1995 1.1995 0 0 1-1.326.1431 6.545 6.545 0 0 0-5.2-.36 6.46 6.46 0 0 0-2.286 1.3689 6.46 6.46 0 0 0-1.538 2.1751 6.712 6.712 0 0 0 3.2 8.528l4.8 2.496a1.2001 1.2001 0 0 1-1.112 2.12 6.55 6.55 0 0 0-5.192-.36 6.47 6.47 0 0 0-2.286 1.3735 6.48 6.48 0 0 0-1.538 2.1785 6.71 6.71 0 0 0-.065 4.8852 6.713 6.713 0 0 0 3.265 3.6348l4.8 2.496c.282.1475.494.401.589.7048.096.3038.066.633-.081.9148a1.2 1.2 0 0 1-.705.59c-.304.095-.633.066-.915-.082a6.58 6.58 0 0 0-2.7-.7216 6.57 6.57 0 0 0-2.756.4656 6.45 6.45 0 0 0-2.327 1.58 6.46 6.46 0 0 0-1.433 2.42 6.698 6.698 0 0 0 .215 4.622 6.69 6.69 0 0 0 3.161 3.378l22.4 11.712a37.28 37.28 0 0 0 19.256 4.104c.352 0 .696-.056 1.04-.056z",
        opacity: ".3"
    }, "151")
], "SelectObject", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 400 300"
});
